import * as React from "react"
import SettingsOverviewCard from "../../molecules/SettingsOverviewCard"
import { useEdgeApi } from "../../../edge/EdgeProvider"
import ButtonRowEditor from "../../molecules/inputs/ButtonRowEditor"
import TextEditor from "../../molecules/inputs/TextEditor"
import FanIcon from "../../atoms/icons/FanIcon"
import { NumberEditor } from "../../../edge/editor"

const FANS_TOOLTIP = `
Note: Turning the fans off may cause the system to overheat, use fan settings with caution. 
When "Auto" is enabled, the fans activate when temperatures get too high, 
and deactivate when the system is within optimal operating temperatures. 
"Off" disables all fans, and "Max" runs all fans at max effect.
`

const WIDGET_ORIGIN_FANS = "Fans"

const FAN_SPEED_DECIMAL_COUNT = 1

const withFanPrecision = (editor?: NumberEditor): NumberEditor | undefined => {
  if (!editor) return undefined
  return {
    ...editor,
    display: (value: number) => value.toFixed(FAN_SPEED_DECIMAL_COUNT),
  }
}

const FansCard: React.FunctionComponent = () => {
  const { config } = useEdgeApi()

  return (
    <SettingsOverviewCard title="Fans" icon={<FanIcon />} tooltip={FANS_TOOLTIP}>
      <ButtonRowEditor label="Fan mode" editor={config.useFanControlMode(WIDGET_ORIGIN_FANS)} />
      {config.useFanControlMode(WIDGET_ORIGIN_FANS)?.value === "manual" && (
        <>
          <TextEditor
            label="Internal fan 1 (%)"
            editor={withFanPrecision(config.useManualFanSpeedInternal1(WIDGET_ORIGIN_FANS))}
          />
          <TextEditor
            label="Internal fan 2 (%)"
            editor={withFanPrecision(config.useManualFanSpeedInternal2(WIDGET_ORIGIN_FANS))}
          />
          <TextEditor
            label="External fan 1 (%)"
            editor={withFanPrecision(config.useManualFanSpeedExternal1(WIDGET_ORIGIN_FANS))}
          />
          <TextEditor
            label="External fan 2 (%)"
            editor={withFanPrecision(config.useManualFanSpeedExternal2(WIDGET_ORIGIN_FANS))}
          />
          <TextEditor label="PB fan 1 (%)" editor={withFanPrecision(config.useManualFanSpeedPb1(WIDGET_ORIGIN_FANS))} />
          <TextEditor label="PB fan 2 (%)" editor={withFanPrecision(config.useManualFanSpeedPb2(WIDGET_ORIGIN_FANS))} />
          <TextEditor
            label="BUC fan 1 (%)"
            editor={withFanPrecision(config.useManualFanSpeedBuc1(WIDGET_ORIGIN_FANS))}
          />
          <TextEditor
            label="BUC fan 2 (%)"
            editor={withFanPrecision(config.useManualFanSpeedBuc2(WIDGET_ORIGIN_FANS))}
          />
        </>
      )}
    </SettingsOverviewCard>
  )
}

export default FansCard
